<template>
  <router-view />
  <!-- <div class="report-complaints">
    <a
      href="https://forms.monday.com/forms/4d9f55ca5274b89f10835e75dfc31058?r=use1"
      target="_blank"
    >
      <figure>
        <img src="/images/ReportComplaints.png?t=1" alt="icon" />
      </figure>
    </a>
  </div> -->
</template>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

@import "~@/assets/css/animate.less";

@font-face {
  font-family: HarmonyOS_Sans_Bold;
  src: url("/font/HarmonyOS_Sans_Bold.woff2");
  font-display: swap;
}

@font-face {
  font-family: HarmonyOS_Sans_Regular;
  src: url("/font/HarmonyOS_Sans_Regular.woff2");
  font-display: swap;
}

body {
  font: 14px/1.6 HarmonyOS_Sans_Regular, system, -apple-system, -apple-system-font, PingFang SC,
    BlinkMacSystemFont, Helvetica Neue, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial,
    sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
}

.font-bold {
  font-family: HarmonyOS_Sans_Bold, system, -apple-system, -apple-system-font, PingFang SC,
    BlinkMacSystemFont, Helvetica Neue, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial,
    sans-serif;
}

@media (-webkit-max-device-pixel-ratio: 1) {
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
}

@media (-webkit-max-device-pixel-ratio: 1) {
  ::-webkit-scrollbar-thumb {
    background-color: #d7d7d7;
    background-clip: padding-box;
    min-height: 28px;
  }
}

@media (-webkit-max-device-pixel-ratio: 1) {
  ::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
}

html ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

html ::-webkit-scrollbar-thumb {
  width: 6px;
  height: 6px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.2);
}

input::-webkit-input-placeholder {
  font-weight: normal;
  color: #c1c1c1;
}

.report-complaints {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}
</style>
